import { View } from "react-native";
import { Text } from "@shared/components/text";
import { IStepComponentProps } from "@shared/components/form/types";
import { dynamicTranslations } from "@shared/utils/dynamicTranslation";
import { Head } from "@shared/components/head";
import { useTranslation } from "react-i18next";
import Button from "@shared/components/md-design-system/Button/Button";
import { useNavigation } from "@react-navigation/native";
import { ActivityName } from "app/_modules/core/types";
import { NativeStackNavigationProp } from "@react-navigation/native-stack";
import { TNavigationStackWithParams } from "app/types";
import { canManualMeasurement } from "app/_modules/core/utils";

export interface IBeforeMeasurementStepContext {
  activityName?: ActivityName;
  activityId?: string;
}

export const BeforeMeasurementStep = ({ translations, context }: IStepComponentProps<undefined, IBeforeMeasurementStepContext>) => {
  const { t: dynamicT } = dynamicTranslations();
  const { t: strictT } = useTranslation();
  const navigation = useNavigation<NativeStackNavigationProp<TNavigationStackWithParams<{ activityName: ActivityName, activityId: string }>>>();
  const activityName = context?.activityName;
  const activityId = context?.activityId;

  const canManualInput = canManualMeasurement(activityName!);

  const handleManualInput = () => {
    navigation.navigate("MeasurementSubmit", { activityName: activityName!, activityId: activityId! });
  };


  return (
    <View className="flex-col gap-4">
      <Head type="h2">{dynamicT(translations?.title || "")}</Head>
      <Text className="text-base leading-normal">{dynamicT(translations?.description || "")}</Text>
      {canManualInput && (
        <View className="flex mt-4">
          <Text className="text-base leading-normal">{strictT("measurement.orProblemOccurred")}</Text>
          <Button variant="link" onPress={handleManualInput}>{strictT("measurement.manualInputLink")}</Button>
        </View>
      )}
    </View>
  );
};